"use client";

// Un séparateur vertical entre deux colonnes : on le fait glisser à la souris (ou au doigt), et les flèches du
// clavier le déplacent de 16 px. Un double-clic rend sa largeur d'origine.

import { useRef, useState } from "react";

export function Redimensionneur({
  className = "",
  libelle,
  onDelta,
  onReset,
}: {
  className?: string;
  libelle: string;
  onDelta: (dx: number) => void;
  onReset: () => void;
}) {
  const [actif, setActif] = useState(false);
  const dernier = useRef<number | null>(null);

  const commencer = (e: React.PointerEvent<HTMLDivElement>) => {
    e.currentTarget.setPointerCapture(e.pointerId);
    dernier.current = e.clientX;
    setActif(true);
    document.body.style.userSelect = "none";
    document.body.style.cursor = "col-resize";
  };

  const deplacer = (e: React.PointerEvent<HTMLDivElement>) => {
    if (dernier.current === null) return;
    const dx = e.clientX - dernier.current;
    dernier.current = e.clientX;
    if (dx) onDelta(dx);
  };

  const finir = (e: React.PointerEvent<HTMLDivElement>) => {
    if (dernier.current === null) return;
    dernier.current = null;
    setActif(false);
    document.body.style.userSelect = "";
    document.body.style.cursor = "";
    if (e.currentTarget.hasPointerCapture(e.pointerId)) e.currentTarget.releasePointerCapture(e.pointerId);
  };

  return (
    <div
      className={`redimensionneur ${actif ? "actif" : ""} ${className}`}
      role="separator"
      aria-orientation="vertical"
      aria-label={libelle}
      tabIndex={0}
      onPointerDown={commencer}
      onPointerMove={deplacer}
      onPointerUp={finir}
      onPointerCancel={finir}
      onDoubleClick={onReset}
      onKeyDown={(e) => {
        if (e.key === "ArrowLeft") {
          e.preventDefault();
          onDelta(-16);
        } else if (e.key === "ArrowRight") {
          e.preventDefault();
          onDelta(16);
        }
      }}
    />
  );
}
